export const SITE_FLAGS = {
    user_training_reports: {
        id: 'user_training_reports',
        value: false,
        description: 'Enables the user training reports feature in Lumos',
        owner: 'Clinical Data',
        name: 'User Training Reports',
        extra: { section: 'Data', dataTestId: 'user-training-reports-flag' },
    },
};
